import React, {Component} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {ModalHeader, ModalBody, ModalFooter, Modal, Button} from "reactstrap";
import {addCode} from "../actions";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import 'ladda/dist/ladda-themeless.min.css';
import CodeForm from './CodeForm';
import PropTypes from 'prop-types';

class CodeCreateButton extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      creating: false,
      errors: {}
    }

    this.codeForm = React.createRef();
  }

  codeCreate(e, data) {
    e.preventDefault();
    this.setState({creating: true});

    this.props.addCode({
      code: data
    }).then(() => {
      this.props.handleChange();
      this.setState({
        creating: false,
        modal: false
      })
    }).catch(e => {
      this.setState({
        creating: false,
        errors: e.response.data.form.errors
      });
    });
  }

  toggleModal(){
    this.setState({
      modal: !this.state.modal
    })
  }

  render() {
    const { creating, errors } = this.state;

    const modal = <Modal isOpen={this.state.modal} toggle={() => this.toggleModal()} size="lg"
                         className={'modal-danger'}>
      <ModalHeader toggle={() => this.toggleModal()} tag="h2"><FormattedMessage id="admin.codeCreateButton.modalHeader" /></ModalHeader>
      <hr className="my-0" />
      <ModalBody>
        <CodeForm errors={errors} onSubmit={this.codeCreate} ref={this.codeForm}/>
      </ModalBody>
      <ModalFooter>
        <FormattedMessage id="_.button.save">{
          (message) => <LaddaButton
            className="btn btn-primary btn-ladda"
            loading={creating}
            data-style={ZOOM_OUT}
            onClick={e => this.codeCreate(e, this.codeForm.current.state)}
          >
            {message}
          </LaddaButton>
        }</FormattedMessage>
        <FormattedMessage id="_.button.cancel">{
          (message) =>
            <Button color="secondary" onClick={() => this.toggleModal()}>{message}</Button>
        }</FormattedMessage>
      </ModalFooter>
    </Modal>;

    return (
      <React.Fragment>
        <Button color="primary" onClick={() => this.toggleModal()}><i className="fas fa-plus" /> <FormattedMessage id="admin.codeCreateButton.button"/></Button>
        {modal}
      </React.Fragment>
    )
  }
}

CodeCreateButton.propTypes = {
  handleChange: PropTypes.func.isRequired
};

export default connect(null, { addCode }, null, {forwardRef: true})(CodeCreateButton);